import { render, staticRenderFns } from "./WeddingPartyMemberProfile.vue?vue&type=template&id=1c05914d&"
import script from "./WeddingPartyMemberProfile.vue?vue&type=script&lang=ts&"
export * from "./WeddingPartyMemberProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports